import { EventBus, EVENTS } from '@/services/event-bus'

function getLineItems(items) {
  return items.map(item => {
    const lineItem = {
      sku: item.variantSku,
      productSku: item.masterSku,
      productName: item.productName,
      productType: item.productType,
      price: item.price,
      currency: item.currency,
      quantity: item.quantity,
      size: item.displaySize,
    }
    return lineItem
  })
}

let isQuickViewViewMode = false

const UPDATE_CART_OPTIONAL_PARAMS = {
  isQuickView: false,
  isGiftCardOrder: false,
  giftCardMessage: '',
}

export default {
  methods: {
    updateCart(
      selectedSku,
      pageContext,
      optionalParams = Object.values(UPDATE_CART_OPTIONAL_PARAMS)
    ) {
      isQuickViewViewMode = optionalParams[0]
      if (!optionalParams[0]) this.$store.dispatch('nav/setAdditionalNav', 'mini-cart')
      this.updateServer(selectedSku, pageContext, 'mini-cart', optionalParams[1], optionalParams[2])
    },

    async updateServer(selectedSku, pageContext, flashContext, isGiftCardOrder, giftCardMessage) {
      const onError = message => {
        const text = message || this.$t('minicart.cart_add_fail')
        this.$store.dispatch('flash/addMessage', {
          text,
          type: 'error',
          context: flashContext,
        })
      }

      const onDone = order => {
        const lineItems = getLineItems(order.items)
        const addedItem = lineItems.filter(lineItem => lineItem.sku == selectedSku.sku)[0]
        this.trackAddToCart(lineItems, addedItem, pageContext)
        this.dispatchAddToCartEvents(lineItems, addedItem)
      }

      this.$store.commit('recommendation/setMiniCartRecIsLoading', true)
      await this.$store.dispatch('order/updateServer', {
        skuId: selectedSku.productVariantId,
        quantity: 1,
        isGiftCardOrder,
        giftCardMessage,
        onError,
        onDone,
      })
    },

    trackAddToCart(lineItems, addedItem) {
      const viewmode = isQuickViewViewMode ? 'quickview' : ''
      this.$notifier.trackEvent({
        action: this.$notifier.ACTIONS.addToCart,
        product: { ...addedItem, viewmode },
      })
      this.$dyClient.trackAddToCart(lineItems, addedItem)
      if (this.isMinicart) this.$dyClient.trackMinicartAddToCart(addedItem)
    },

    dispatchAddToCartEvents(lineItems, addedItem) {
      window.dispatchEvent(new CustomEvent('on:addtocart'))
      EventBus.$emit(EVENTS.minicart.update, { detail: { addToCart: true } })
      window.dispatchEvent(
        new CustomEvent('on:filter-page-add-to-cart', {
          detail: { lineItems, addedItem },
        })
      )
    },
  },
}
